import type { FaireProductEntity } from "../../entity_types/product";

export const p_vh83g8t7um: FaireProductEntity = {
  token: "p_vh83g8t7um",
  type: "product",
  name: "Bird Anatomy Sticker Book",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/cd634def44255907512c0835e56c2e73bb8679a8102bc814c2ff177a5a612f89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f5320f6740c871004709b8edebff1c2d5d94a3dd77c6a54ae6830242cf691f3.jpeg",
    "https://cdn.faire.com/fastly/5b7a6897f516abc46f4ff53dd2c0a9e0e76de43dfe7d189931fe50223875b7f4.jpeg",
    "https://cdn.faire.com/fastly/00349f1fe0332f77e64d09fe4534cfb3989daa89af30f0036c31e5961bf23113.jpeg",
    "https://cdn.faire.com/fastly/57bcb0c4ed8e058af13465044e6e43742443831af0c216c7d5cdcbffa4c93f1c.jpeg",
    "https://cdn.faire.com/fastly/fb1f83ca5a38d66aaac6984897bdd81c014d0e6b44583c8f952046ebbbe67c2d.jpeg",
    "https://cdn.faire.com/fastly/9cd5093879308673af456f56b931913ba0e6ef5970f5c1eae4b1033cc62aa2f6.jpeg",
    "https://cdn.faire.com/fastly/88e0f5d30a2854b0d30ddb54e34d7d4c402e2e41e8e72f36e15bc44426a387da.jpeg",
    "https://cdn.faire.com/fastly/41c3ed9c4bd6e2e82ad0498b1b3ca7aef36cf7a0b6d463a51533888f12d253a1.jpeg",
    "https://cdn.faire.com/fastly/70f722ac64d726336806ead0ac62e61297d721acf2ea4f8b7937d6916fe29e87.jpeg",
    "https://cdn.faire.com/fastly/245ea36fa7d59cac55181a4889e450f97e62abfd64f946d48043b6eb4f5a9ae6.jpeg"
  ],
  priceDollars: 6.5,
  description: "Celebrate your favorite feathered friends with over 600 stickers from beloved illustrator Julia Rothman. Bird lovers of all ages will be delighted by Bird Anatomy Stickers. From familiar backyard birds like the black cap chickadee and downy woodpecker to exotic species like the great hornbill and the blue-throated hillstar, you’ll find over 600 stickers with every kind of bird imaginable, along with stickers related to the wider avian world like eggs, feathers, nests, and more. Julia Rothman’s stunning illustrations are captured on gorgeous, high-quality stickers that are easy to peel, adhere strongly, and add a splash of feathered fun wherever you put them.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:49.300Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
